module.exports = __webpack_public_path__ + "img/arrows.265205bf.svg";